import { FC } from "react";
import styles from "./wholesale-box.module.css";

interface WholesaleBoxProps {
  className?: string;
}

const WholesaleBox: FC<WholesaleBoxProps> = ({ className }) => {
  return (
    <div className={`${styles.wholesaleBoxWrapper} ${className}`}>
      <span className={`${styles.icon} icon-light-package`} />
      <div className={styles.text}>Producto al por mayor</div>
    </div>);

};

export default WholesaleBox;